import { render, staticRenderFns } from "./serve-citizen-table.vue?vue&type=template&id=4f69f04c"
import script from "./serve-citizen-table.vue?vue&type=script&lang=ts"
export * from "./serve-citizen-table.vue?vue&type=script&lang=ts"
import style0 from "./serve-citizen-table.vue?vue&type=style&index=0&id=4f69f04c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports